
import { FileDTO } from "bnsights-control-library"

export class LicenseModel
{
    LicenseFile:FileDTO
    appendExisting :boolean=false;
}
     